import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import CloseIcon from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { showPopup, closePopup } from '../../actions/uiActions'
import { startDbJob } from '../../actions/dbFunctionsActions'

function FireDbJob(props) {
    const [disableButton, setDisableButton] = useState(false)

    function handleClick(event) {
        event.preventDefault()
        props.closePopup()
    }
    
    function initiateJob(event) {
        event.preventDefault()
        setDisableButton(true)
        props.startDbJob(props.popupInfo.jobData.id)
    }

    function renderDbUploadSubmitButton() {
        if (disableButton) {
            return (<button className="btn" disabled onClick={(e) => e.preventDefault()}>Start</button>)    
        }
        return (<button className="btn" onClick={initiateJob}>Start</button>)
    }

    // This is the render logic, no need to declare another method is a functional component
    return (<Dialog
        open={true}
        onClose={handleClick}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <CloseIcon onClick={handleClick} className="closePoup" />
        <DialogTitle id="alert-dialog-title" className="changepassdialog">
            {`Start DB Job: ${props.popupInfo.jobData.jobName}`}
            {' '}
        </DialogTitle>
        <DialogContent>
            <div className="passwordResetbox">
                {renderDbUploadSubmitButton()}
            </div>
        </DialogContent>
    </Dialog>)
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, showPopup, startDbJob }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FireDbJob)